// src/pages/help/helpI18n.js
// Chaînes du centre d'aide (namespace i18next « help »). Le contenu long des
// guides vit dans helpContent.js — ici uniquement l'habillage (titres, boutons,
// assistance) partagé par le hub et les pages guide.
import i18n from "../../i18n";

const fr = {
  title: "Centre d’Aide FullMetrix",
  subtitle: "Guides, tutoriels et réponses claires pour maîtriser FullMetrix (plateforme premium de FullMargin).",
  searchPlaceholder: "Rechercher un guide, une fonctionnalité, une question…",
  labels: {
    copy: "Copier",
    copied: "Copié !",
    noResults: "Aucun résultat. Essayez un autre mot-clé.",
    results: "Résultats",
    clear: "Effacer",
    close: "Fermer",
    tip: "Astuce",
    readMin: "{{count}} min de lecture",
    openGuide: "Ouvrir le guide",
    backToHelp: "Retour au centre d’aide",
    guides: "Guides",
    topicsTitle: "Choisissez un sujet",
    topicsDesc: "Chaque sujet ouvre son propre guide, avec les étapes et les questions fréquentes.",
    faqTitle: "Questions fréquentes",
    briefTitle: "En bref",
    stepsTitle: "Étapes clés",
    tipsTitle: "Bonnes pratiques",
    relatedTitle: "À lire ensuite",
    openFeature: "Ouvrir la fonctionnalité",
    notFound: "Ce guide n’existe pas (ou plus).",
    howItWorks: "Comment ça marche ?",
  },
  support: {
    title: "Assistance FullMargin",
    desc: "WhatsApp ou Email. Ajoutez votre email/ID FullMargin + une capture si possible.",
    ctaWhatsApp: "Écrire sur WhatsApp",
    ctaEmail: "Écrire par Email",
    note: "Temps de réponse : plus rapide si vous joignez une capture + le module concerné.",
    prefillWhatsApp: "Bonjour, j’ai besoin d’aide sur FullMetrix :",
    subjectEmail: "Assistance FullMetrix",
    prefillEmail:
      "Bonjour,\n\nJ’ai besoin d’aide sur FullMetrix.\n\n• Mon email/ID FullMargin : \n• Problème : \n• Module concerné : \n• Capture (si possible) : \n\nMerci.",
    copyNumber: "Copier le numéro",
    copyEmail: "Copier l’email",
    blockTitle: "Besoin d’un coup de main ?",
    blockDesc: "L’équipe est disponible pour vous aider rapidement.",
  },
};

const en = {
  title: "FullMetrix Help Center",
  subtitle: "Guides, tutorials and clear answers to master FullMetrix (FullMargin premium platform).",
  searchPlaceholder: "Search a guide, a feature, a question…",
  labels: {
    copy: "Copy",
    copied: "Copied!",
    noResults: "No results. Try another keyword.",
    results: "Results",
    clear: "Clear",
    close: "Close",
    tip: "Tip",
    readMin: "{{count}} min read",
    openGuide: "Open guide",
    backToHelp: "Back to help center",
    guides: "Guides",
    topicsTitle: "Pick a topic",
    topicsDesc: "Each topic opens its own guide, with steps and frequent questions.",
    faqTitle: "Frequently asked questions",
    briefTitle: "In short",
    stepsTitle: "Key steps",
    tipsTitle: "Good practices",
    relatedTitle: "Read next",
    openFeature: "Open the feature",
    notFound: "This guide does not exist (any more).",
    howItWorks: "How does it work?",
  },
  support: {
    title: "FullMargin Support",
    desc: "WhatsApp or Email. Include your FullMargin email/ID + a screenshot if possible.",
    ctaWhatsApp: "Message on WhatsApp",
    ctaEmail: "Email support",
    note: "Faster replies with a screenshot + the module involved.",
    prefillWhatsApp: "Hello, I need help with FullMetrix:",
    subjectEmail: "FullMetrix Support",
    prefillEmail:
      "Hello,\n\nI need help with FullMetrix.\n\n• My FullMargin email/ID:\n• Issue:\n• Module:\n• Screenshot (if possible):\n\nThanks.",
    copyNumber: "Copy number",
    copyEmail: "Copy email",
    blockTitle: "Need a hand?",
    blockDesc: "Our team is available to help you quickly.",
  },
};

// addResourceBundle en mode deep+overwrite : recharge propre en dev (HMR).
i18n.addResourceBundle("fr", "help", fr, true, true);
i18n.addResourceBundle("en", "help", en, true, true);

export function helpLang(language) {
  return String(language || i18n.language || "fr").startsWith("en") ? "en" : "fr";
}
